import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DealApplicationRequirement } from 'app/services/deals/deal-application-requirement.model';
import { fileTypesAccepted } from 'app/models/const/fileTypesAccepted';
import { Document } from 'app/models/dto/document.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-deal-document',
  templateUrl: './deal-document.component.html',
  styleUrls: ['./deal-document.component.scss'],
  standalone: false
})
export class DealDocumentComponent implements OnInit {

  @Input() documentRequirement: DealApplicationRequirement;
  @Input() documents: Document[];
  @Input() dealStage: string;
  @Input() readOnly: boolean = false;
  @Input() uploadingDocument: boolean;
  @Output() attachDocument = new EventEmitter<Document>();
  @Output() detachDocument = new EventEmitter<Document>();
  @Output() docsUploaded = new EventEmitter<{
    category: {
      display: string;
      value: string;
      alias: string;
      attributeId: number;
    };
    documents: FileList;
  }>();

  typesAccepted = fileTypesAccepted;
  filteredDocuments: Document[] = [];
  selectedDocuments: Document[] = [];

  constructor() {}

  ngOnInit(): void {
    this.filteredDocuments = this.documents.filter(doc => doc.scanStatus === 'CLEAN');
  }

  uploadDocuments(documents: FileList) {
    this.docsUploaded.emit({
      category: this.documentRequirement.category,
      documents
    });
  }

  docSelected(document: Document) {
    return this.selectedDocuments.find(d => d.id === document.id) !== undefined;
  }

  toggleSelected(document: Document, checked: boolean) {
    if (checked) {
      this.selectedDocuments.push(document);
    } else {
      this.selectedDocuments = this.selectedDocuments.filter(d => d.id !== document.id);
    }
  }

  attachSelected() {
    this.selectedDocuments.forEach(document => {
      document.category = this.documentRequirement.category.value;
      this.attachDocument.emit(document);
    });
    this.selectedDocuments = [];
  }

  detach(document: Document) {
    this.detachDocument.emit(document);
  }

  getViewUrl(docId: number): string {
    return `${environment.API_URL}/document/${docId}?stream=1`;
  }

  openDocument(document: Document) {
    if (document.scanStatus === 'CLEAN') {
      window.open(this.getViewUrl(document.id), '_blank');
    }
  }
}
